import { useEffect, useState } from "react"

/**
 * Tracks browser network connectivity, reacting to the window online/offline
 * events. Removes its listeners on unmount (handheld memory-leak guard, §10).
 *
 * Returns `true` when online. Consumers that want the inverse simply negate.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setOnline(true)
    const handleOffline = () => setOnline(false)
    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)
    return () => {
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])

  return online
}
